import { call, put, takeEvery } from 'redux-saga/effects';
import { changeRefBikeLeadRequest, changeRefBikeLeadRequestSuccess } from '../actions/change_ref_bike_lead.actions';
import { GET_REF_BIKE_MODEL_REQUEST } from '../constants/get_ref_bike_model.constants';
import { updateBikeProfile } from '../../requests/change_lead_profile_request';
import { getLeadProfileWithRefs } from '../../requests/get_lead_profile_request';
import {
    getLeadProfileWithRefsRequestFailure,
    getLeadProfileWithRefsRequestSuccess,
} from '../actions/get_lead_profile_with_refs.actions';

function* getRefBikeModelsRequest({ params }) {
    const update_data = {
        ref_bike_brand: undefined,
        ref_bike_model: undefined,
        ref_bike_variant: undefined,
        vrm: undefined,
        experian_name: undefined,
        'unmaped_data.bike_model': undefined,
        'unmaped_data.bike_model_variant': undefined,
        'unmaped_data.bike_year': undefined,
        'unmaped_data.bike_cc': undefined,
    };
    update_data.ref_bike_brand = params.vrm_data.data.brand_id && params.vrm_data.data.brand_id !== '' ? params.vrm_data.data.brand_id : undefined;
    update_data.vrm = params.vrm_data.data.experian.vrm;
    update_data.experian_name = params.vrm_data.data.experian.makeModel;
    update_data.year_code = params.vrm_data.data.year_code;

    update_data['unmaped_data.bike_model'] = params.vrm_data.data.experian.model;
    update_data['unmaped_data.bike_year'] = params.vrm_data.data.experian.yearOfManufacture;
    update_data['unmaped_data.bike_cc'] = params.vrm_data.data.experian.engineCapacity;

    update_data.ref_bike_model = params.vrm_data.data.model_id && params.vrm_data.data.model_id !== '' ? params.vrm_data.data.model_id : undefined;
    update_data.ref_bike_variant = params.vrm_data.data.variant_id && params.vrm_data.data.variant_id !== '' ? params.vrm_data.data.variant_id : undefined;


    const response = yield call(updateBikeProfile, params.brandId, update_data);

    if (response) {
        const lead = yield call(getLeadProfileWithRefs, params.lead_id);
        lead.result
            ? yield put(getLeadProfileWithRefsRequestSuccess(lead.options.ref_bike_lead))
            : yield put(getLeadProfileWithRefsRequestFailure(lead.error));
        yield put(changeRefBikeLeadRequestSuccess('ref_bike_lead', response.options));
    }
}

export default function* getRefBikeModelsSaga() {
    yield takeEvery(GET_REF_BIKE_MODEL_REQUEST, getRefBikeModelsRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/get_ref_bike_model.saga.js